import { useEffect, useState } from 'react'
import { SUBCATEGORY_STAT_CARDS } from '../../../../Utilities/APIs'
import './OrganizationStatSection.css'

function OrganizationStatSection({statCards, subcategory}) {

    const [statLabels, setStatLabels] = useState(null)

    useEffect(() => {
        async function getAndSetLabels() {
            const labelRes = await fetch(SUBCATEGORY_STAT_CARDS + 'getStatCardsFromSubcategory/' + subcategory)
            // const labelRes = await fetch(SUBCATEGORY_STAT_CARDS)
            const labelData = await labelRes.json()
            setStatLabels(labelData)
        }

        getAndSetLabels()
    }, [subcategory])

    return (
        <div className='stat_counter grid_container'>
            {statCards?.map(c => (
                <div className="grid_item" key={c._id}>
                    <span className='number'>{c.amount}</span>
                    <span className='title'>{statLabels?.find(l => l._id === c.subcatStatCard).name}</span>
                </div>
            ))}
        </div>
    )
}

export default OrganizationStatSection